module.exports = __webpack_public_path__ + "img/1474013786.4a692585.jpg";